export const customSerialization = [
    (value) => {
        if (value === undefined || value === 'undefined') {
            return JSON.stringify(null);
        }
        return JSON.stringify(value);
    },
    (value) => {
        if (value === undefined || value === 'undefined') {
            return null;
        }
        return JSON.parse(value);
    }
];
